import { render, staticRenderFns } from "./deliveryAddress.vue?vue&type=template&id=255a49d8&scoped=true&"
import script from "./deliveryAddress.vue?vue&type=script&lang=js&"
export * from "./deliveryAddress.vue?vue&type=script&lang=js&"
import style0 from "./deliveryAddress.vue?vue&type=style&index=0&id=255a49d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a49d8",
  null
  
)

export default component.exports